import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import images from "../../../images";
import Button from "../../../components/common/Button/Button";
import HeaderReferral from "./HeaderReferral";

const Referral = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [recipientName, setRecipientName] = useState("Abigail");
  const [referralMessage, setReferralMessage] = useState(
    "Hey Abigail, I recalled you mentioned wanting to eat a clean diet? Let's try it together someday!"
  );

  const [isDropDownOpen, setIsDropDownOpen] = useState(false);

  const handleShare = () => {
    console.log("Sharing referral:", { recipientName, referralMessage });
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col w-full max-w-[480px] bg-[#FFFFFF] h-screen">
      <HeaderReferral
        menuIcon={images.ThreeDotBlueIcon}
        onMenuClick={() => setIsDropDownOpen(!isDropDownOpen)}
        isDropDownOpen={isDropDownOpen}
        onDropDownBackClick={handleBack}
      />

      <div className="flex flex-col flex-1 justify-between overflow-y-hidden">
        <div className="flex-1 overflow-y-auto section-content pb-[200px] scrollbar-hide px-6 pt-6 mt-6">
          <div className="flex flex-col gap-[18px]">
            <h1 className="text-[#253FF6] text-2xl font-bold">
              {t("referral.title") || "Referral"}
            </h1>

            <label className="text-[#A0A0A0] text-base font-normal">
              {t("referral.recipientName") || "Recipient's name"}
            </label>
            <input
              type="text"
              value={recipientName}
              onChange={(e) => setRecipientName(e.target.value)}
              className="w-full h-[50px] rounded-md border border-stone-200 focus:outline-none focus:border-[#A0A0A0] px-4 text-black font-medium transition-colors duration-200"
              placeholder={t("referral.enterName")}
            />

            <label className="text-[#A0A0A0] text-base font-normal">
              {t("referral.referralMessage") || "Referral message"}
            </label>
            <textarea
              value={referralMessage}
              onChange={(e) => setReferralMessage(e.target.value)}
              className="w-full min-h-[150px] rounded-md border border-stone-200 focus:outline-none focus:border-[#A0A0A0] px-4 py-3 text-[#A0A0A0] text-base resize-none transition-colors duration-200 leading-relaxed"
              placeholder={t("referral.enterMessage")}
            />
            <Button
              className="w-full rounded-md bg-[#253FF6] text-[20px] text-white font-medium flex items-center justify-center gap-2 py-2 px-[18px]"
              onClick={handleShare}
              text={t("referral.shareButton")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Referral;
